export default __webpack_public_path__ + "static/media/Destination4.c19a433b.png";